import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import SummaryApi from "./common";
import ErrorBoundary from "./components/ErrorBoundary";
import Footer from "./components/Footer";
import Header from "./components/Header";
import MobileNavbar from "./components/MobileNavbar";
import Context from "./context";
import { fetchCsrfToken, request } from "./helpers/request";
import ScrollToTop from "./helpers/ScrollToTop";
import { setUserDetails } from "./store/userSlice";

function App() {
  const dispatch = useDispatch();
  const [cartProductCount, setCartProductCount] = useState(0);
  const user = useSelector((state) => state?.user?.user);

  const fetchUserDetails = useCallback(async () => {
    try {
      const dataResponse = await request(SummaryApi.current_user);

      const dataApi = await dataResponse.json();

      if (dataApi.success) {
        dispatch(setUserDetails(dataApi.data));
      } else {
        dispatch(setUserDetails(null));
      }
    } catch (error) {
      console.error("Error fetching user details", error);
    }
  }, [dispatch]);

  const fetchUserAddToCart = useCallback(async () => {
    const isLoggedIn = !!user;

    if (!isLoggedIn) {
      // Guest Count
      const cart = JSON.parse(localStorage.getItem("guestCart") || "[]");
      const count = cart.reduce((prev, curr) => prev + curr.quantity, 0);
      setCartProductCount(count);
      return;
    }

    try {
      const dataResponse = await request(SummaryApi.addToCartProductCount);
      if (dataResponse.ok) {
        const dataApi = await dataResponse.json();
        setCartProductCount(dataApi?.data?.count || 0);
      }
    } catch (error) {
      console.error("Error fetching cart count", error);
    }
  }, [user]);

  useEffect(() => {
    fetchCsrfToken();
    fetchUserDetails();

    // Listen for custom cart updates (for guest cart)
    window.addEventListener("cartUpdate", fetchUserAddToCart);
    return () => window.removeEventListener("cartUpdate", fetchUserAddToCart);
  }, [fetchUserDetails, fetchUserAddToCart]);

  // Fetch cart count whenever user changes
  useEffect(() => {
    fetchUserAddToCart();
  }, [user, fetchUserAddToCart]);
  const location = useLocation();
  const isAdminPanel = location.pathname.includes("admin-panel");

  return (
    <ErrorBoundary>
      <Context.Provider
        value={{
          fetchUserDetails,
          cartProductCount,
          fetchUserAddToCart,
        }}
      >
        <ScrollToTop />
        <ToastContainer position="top-center" />

        {!isAdminPanel && <Header />}
        <main
          className={`min-h-[calc(100vh-120px)] ${!isAdminPanel ? "pt-16 lg:pb-0" : ""}`}
        >
          <Outlet />
        </main>
        {!isAdminPanel && !location.pathname.startsWith("/product/") && (
          <MobileNavbar />
        )}
        {!isAdminPanel && <Footer />}
      </Context.Provider>
    </ErrorBoundary>
  );
}

export default App;
